import { PageHeader } from '@parsina/framework';
import { PANEL_PAD } from '../../constants/density';
import { useTranslation } from '../../i18n';
import MembershipSections from '../Start/MembershipSections.jsx';

/**
 * «دعوت‌ها و درخواست‌ها» — the in-shell inbox, for someone who already has a clinic
 * and has been invited to another (§5.5).
 *
 * The pre-membership version of the same two sections lives on «شروع»; this is the
 * same component in the panel's chrome. Person-scoped, so it is NOT under
 * `/c/:ref` — an invitation belongs to the person, not to whichever clinic they
 * happen to be looking at.
 */
export default function InvitationsScreen() {
  const { t } = useTranslation();
  return (
    <div style={{ padding: PANEL_PAD.regular, maxWidth: 720 }}>
      <PageHeader
        title={t('clinic.invitations.title')}
        subtitle={t('clinic.invitations.subtitle')}
      />
      <MembershipSections />
    </div>
  );
}
